import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import classname from 'classnames';
import TopNav from '../includes/TopNav.js';
import Pager from './Pager.js';
import EditorProfileForm from './EditorProfileForm.js';
import {Helmet} from 'react-helmet';
import {getFormattedTime, docStatusToString} from '../../util/displayUtils.js';

import {
  updateTab,
  getPossiblePapersForEdit,
  postEditedPaper,
  getAvailablePapers,
  EditorgetMyEdits,
  updateSubmissionInput,
  updateMySubmissionInput,
  getCompletedSubmissions,
  postEditedPaperComplete,
  invoiceSelect,
  generateInvoice,
  getUserDetails,
  cancelEdit,
  updateUserIdInput,
  patchUserId,
  getInvoices,
  getMyEditorPapers,
  getEditorPrice,
  getEditorContactInfo
} from '../../actions/editordashboard.js'
// import PaperLoading from '../Home/PaperLoading'
import UpdatePassword from './updatePassword.js';
import moment from 'moment'
import config from '../../config/config.json'
import { updateUserProfile } from '../../actions/user.js'; 

const editFileNameStyle = {
  'fontSize': '12px',
  'color': '#000000',
  'lineHeight': 'initial'
}
class EditorDashboard extends Component {
  constructor(props) {
      super(props)
      this.state = {"allowedMoreEdits": true}
  }
  componentDidMount(props) {
      this.getAvailablePapers();
      this.EditorgetMyEdits();
      this.getCompletedSubmissions();
      this.getEditorContactInfo();
  }
  getAvailablePapers() {
      this.props.dispatch(getAvailablePapers(1, function(res){
        if(this.state.allowedMoreEdits && res === false) {
          this.setState({'allowedMoreEdits': false})
        }
      }.bind(this)))
      setTimeout(function(){
        this.getAvailablePapers(); 
      }.bind(this), 60*1000);
  }
  EditorgetMyEdits() {
      this.props.dispatch(EditorgetMyEdits())
      setTimeout(function(){
        this.EditorgetMyEdits(); 
      }.bind(this), 60*1000);
  }
  getEditorContactInfo() {
    this.props.dispatch(getEditorContactInfo());
  }
  getCompletedSubmissions(){
      this.props.dispatch(getCompletedSubmissions())
      setTimeout(function(){
        this.getCompletedSubmissions(); 
      }.bind(this), 60*1000);
  }
  componentWillUpdate(props){
    if( this.props.User && this.props.User.fetched ) { // only after session fetched
      if( this.props.User.role != "editor" || !this.props.User.loggedin) {
        window.location.href = "/login";
      }
    }
      // if(this.props.Signup.signin.level){
      //   this.getSubmission(this.props.Signup.signin.level)
      // }
      // this.getSubmission(this.props.Signup.signin.level)
      // this.getMySubmission()
      // this.getCompletedSubmissions()
      // this.getUserDetails()
      // this.getInvoices()
      // this.checkForUpdates()
  }
  checkForUpdates(){
      // setTimeout(function() {
      //     this.getSubmission()
      //     this.getMySubmission()
      //     this.getCompletedSubmissions()
      //     this.getUserDetails()
      //     this.getInvoices()
      //     this.checkForUpdates()
      //     console.log("Checking for updates!")
      // }.bind(this), 2500);
  }
  getUserDetails(){
      this.props.dispatch(getUserDetails())
  }
  updateUserIdInput(key, e) {
      this.props.dispatch(updateUserIdInput(key, e.target.value))
  }
  patchUserId(){
      this.props.dispatch(patchUserId(this.props.Dashboard.user_details, () => {}))
  }
  invoiceSelect(i){
      this.props.dispatch(invoiceSelect(i));
  }
  generateInvoice(){
      var self = this;
      console.log('generate invoice:');
      console.log(this.props.EditorDashboard.invoiceSelect);
      this.props.dispatch(generateInvoice(this.props.EditorDashboard.invoiceSelect, () => {
        self.props.dispatch(getInvoices())
        self.props.dispatch(getCompletedSubmissions())
      }))
  }
  postEditedPaperComplete(SubmissionId, e) {
      var self = this
      var foundSubmission = null;
      for(var i=0;i<this.props.EditorDashboard.editorSubmissionsinEdit.length;i++) {
        if(this.props.EditorDashboard.editorSubmissionsinEdit[i].doc_id == SubmissionId) {
          foundSubmission = this.props.EditorDashboard.editorSubmissionsinEdit[i];
        }
      }
      console.log(foundSubmission);
      var msg = "The original file is named: "+foundSubmission.doc_name;
      if(foundSubmission.file_name1) {
        msg += "\nThe edited file is named: "+foundSubmission.file_name1;
      }
      if(foundSubmission.file_name2) {
        msg += "\nand the clean file is named: "+foundSubmission.file_name2;
      }
      msg += "\nIf this doesn't look right, click cancel and re-upload both documents.";
      if(!window.confirm(msg)) {
        return false;
      }
      this.props.dispatch(postEditedPaperComplete(SubmissionId, () => {
          // self.props.dispatch(getMySubmission())
          // self.props.dispatch(getCompletedSubmissions())
          this.getAvailablePapers()
          this.EditorgetMyEdits()
      }))
  }
  getInvoices(){
      var self = this
      this.props.dispatch(getInvoices());
  }
  updateMySubmissionInput(i, key, value, e) {
      this.props.dispatch(updateMySubmissionInput(i, key, value))
  }
  updateTab(index) {
      this.props.dispatch(updateTab(index))
  }
  triggerUpload(i, type, e) {
    console.log('<--><--><--><--><--><--><--><--><--><--><--><--> UPLOAD TRIGGERED <--><--><--><--><--><--><--><--><--><--><--><-->')
      if(type == 1){
          document.querySelector('.upload-file-1' + i).click()
      }else if (type == 2) {
          document.querySelector('.upload-file-2' + i).click()
      }
  }
  postEditedPaper(id, type, e) {
      console.log('inside post edited paper ');
      console.log(id);
      console.log(type);
      var self = this
      this.props.dispatch(postEditedPaper(e.target.files[0], id, type, () => {
          this.getAvailablePapers()
          this.EditorgetMyEdits()
          // self.props.dispatch(getSubmission())
          // self.props.dispatch(getMySubmission())
          self.props.dispatch(getCompletedSubmissions())
      }))
  }
  updateSubmissionInput(index, key, value, e) {
      this.props.dispatch(updateSubmissionInput(index, key, value))
  }
  cancelEdit(body, doc_id){
      console.log("inside canceledit ---->---->---->---->")
      console.log(body);
      var self = this
      this.props.dispatch(cancelEdit(body, () => {
        this.getAvailablePapers()
        this.EditorgetMyEdits()

          // self.props.dispatch(getMySubmission())
      }))
  }
  getEditorProfileProps(){
    let data = {
      lastName: this.props.User.last_name, // not currently used in form
      firstName: this.props.User.first_name, // not currently used in form
      phone: this.props.User.phone,
      email: this.props.User.email,
      hstnumber: this.props.User.hstnumber,
      hstprovince: this.props.User.hstprovince,
      contact: this.props.EditorDashboard.contact,
    }
    let initialValues = {
      initialValues: data,
      data
    }
    return initialValues;
  }
  submitEditorUpdate(data) {
    // function to send profile update to API
    console.log("going to send to API ");
    console.log(data);
    updateUserProfile(data);
  }
  getNextPageCompleted(page) {
    this.props.dispatch(getCompletedSubmissions(page));
  }
  getNextPageInEdit(page) {
    this.props.dispatch(EditorgetMyEdits(page));
  }
  getNextPageAvailable(page) {
    this.props.dispatch(getAvailablePapers(page, function(res){
      if(this.state.allowedMoreEdits && res === false) {
        this.setState({'allowedMoreEdits': false})
      }
    }.bind(this)))
  }
  render() {
      var tab1 = classname({ editorbutton: true, easing: true, active_tab: this.props.Dashboard.tab === 1 })
      var tab2 = classname({ editorbutton: true, easing: true, active_tab: this.props.Dashboard.tab === 2 })
      var tab3 = classname({ editorbutton: true, easing: true, active_tab: this.props.Dashboard.tab === 3 })
      var tab4 = classname({ editorbutton: true, easing: true, active_tab: this.props.Dashboard.tab === 4 })
      var tab5 = classname({ editorbutton: true, easing: true, active_tab: this.props.Dashboard.tab === 5 })
      var page1 = classname({ editorpage: true, easing: true, activepage: this.props.Dashboard.tab === 1 })
      var page2 = classname({ editorpage: true, easing: true, activepage: this.props.Dashboard.tab === 2 })
      var page3 = classname({ editorpage: true, easing: true, activepage: this.props.Dashboard.tab === 3 })
      var page4 = classname({ editorpage: true, easing: true, activepage: this.props.Dashboard.tab === 4 })
      var page5 = classname({ page: true, easing: true, active: this.props.Dashboard.tab === 5 })
      //
      // var invoice_date_plug = this.props.Dashboard.invoices[this.props.Dashboard.invoices.length -1];
      // if(invoice_date_plug){
      //     invoice_date_plug = moment(invoice_date_plug.invoiced_date).format('LLL')
      // }

      var newsubmissions = this.props.Dashboard.availableforeditsubmissions.map((submission, i) => {
        var editor_doccost = getEditorPrice(submission);
        return(
          <tr key={i}>
            <td><Link to={`/editordashboard/view/${submission.doc_id}/`}>{submission.doc_name}</Link></td>
            <td>{submission.word_count}</td>
            <td>${editor_doccost}</td>
            <td>{submission.time_limit}</td>
            <td>{getFormattedTime(submission.due_date)}</td>
            <td><Link to={`/editordashboard/view/${submission.doc_id}/`}>Accept Submission</Link></td>
          </tr>
        )
      })

      var inedit_papers = this.props.EditorDashboard.editorSubmissionsinEdit.map((submission, i) => {
        var edit_path1;
        var edit_path2;
        var completiondiv;
        let timer_comp;
        let cancel_button;
        let finaltimer = 'Final 30 Minutes!';
        cancel_button = <a className="options" onClick={this.cancelEdit.bind(this, submission.doc_id)}>Cancel</a>
        // edit_path1  = <div><br/><a href={config.BASE + submission.edit_path1}>Download</a></div>
        if(submission.edit_path1){
            edit_path1  = <div><br/><Link to={config.BASE + submission.edit_path1}>Download</Link><br /><span style={editFileNameStyle}>file: {submission.file_name1}</span></div>
            completiondiv = <a className="options" onClick={this.postEditedPaperComplete.bind(this, submission.doc_id)}>Complete Submission</a>
        }else{
            edit_path1 = <div><br/></div>
            completiondiv = <b>Upload 1st edit</b>
        }
        if(submission.edit_path2){
            edit_path2 = <div><br/><a className="options" href={config.BASE + submission.edit_path2}>Download</a><br /><span style={editFileNameStyle}>file: {submission.file_name2}</span></div>
        }else{
            edit_path2 = <div></div>
        }
        var popup = classname({
          'popup': true,
          'easing': true,
          'active': submission.active === true
        })
        //{timer_comp}
        var editor_doccost = getEditorPrice(submission);
        return(
          <tr key={i}>
          <td><Link to={`/editordashboard/view/${submission.doc_id}/`}>{submission.doc_name}</Link></td>
          <td>{submission.word_count}</td>
          <td>${editor_doccost}</td>
          <td>{submission.time_limit}</td>
          <td>{getFormattedTime(submission.paid_date)}</td>
          <td>{getFormattedTime(submission.due_date)}</td>
          <td className="options">
              <input type="file" className={"upload-file-1" + i} onChange={this.postEditedPaper.bind(this, submission.doc_id, 1)} onClick={(event)=> {event.target.value = null}} style={{display: 'none'}}/>
              <a onClick={this.triggerUpload.bind(this, i, 1)}>Submit (with edits)</a>
              {edit_path1}
          </td>
          <td className="options">
              <input type="file" className={"upload-file-2" + i} onChange={this.postEditedPaper.bind(this, submission.doc_id, 2)} onClick={(event)=> {event.target.value = null}} style={{display: 'none'}}/>
              <a onClick={this.triggerUpload.bind(this, i, 2)}>Submit Clean Version</a>
              {edit_path2}
          </td>
          {/* ----- REMOVED FOR NOW - MISSING API -----
          <td>
            {cancel_button}
          </td>*/}
          <td className="options">
              <a href={config.BASE + submission.doc_path} target="_blank">Download</a>
          </td>
          <td>{completiondiv}</td>
          </tr>
        )
      }, this);

      var complete_edits = this.props.EditorDashboard.editorSubmissionsComplete.map((submission, i) => {
        var edit_path1;
        var edit_path2;
        var is_rated;
        if(submission.editor_rating_id){
          is_rated =  <Link to={`/editordashboard/rating/${submission.doc_id}/`}>{submission.rating_star}</Link>
        }else {
          is_rated = <div>-</div>
        }
        if(submission.edit_path2){
            edit_path2 = <div><a href={config.BASE + submission.edit_path2}>Download</a></div>
        }else{
            edit_path2 = <div></div>
        }
        var invoice_path;
        var editor_is_paid;
        var popup = classname({
          'popup': true,
          'easing': true,
          'active': submission.active === true
        })
        if(!(submission.invoice_id) || submission.invoice_id == 0){
           invoice_path = <label><input type="checkbox" name="vehicle" value={i} onChange={this.invoiceSelect.bind(this, submission.doc_id)}/>Invoice</label>
        }else{
           invoice_path = <div><a href={config.BASE + 'uploads/invoices/invoice_' + submission.invoice_id+'.xlsx'}>{submission.invoice_id}</a></div>
        }
        if(submission.editor_is_paid == 1){
          editor_is_paid = <i className="fa fa-check" aria-hidden="true"></i>
        }else{
          editor_is_paid = <div></div>
        }
        var editor_doccost = getEditorPrice(submission);
        return(
          <tr key={i}>
            <td><Link to={`/editordashboard/view/${submission.doc_id}/`}>{submission.doc_name}</Link></td>
            <td>${editor_doccost}</td>
            <td>{getFormattedTime(submission.upload_date)}</td>
            <td>{getFormattedTime(submission.due_date)}</td>
            <td>{editor_is_paid}</td>
            <td>{is_rated}</td>
          </tr>
        )
      })

    return(
      <div>
        <Helmet>
          <title>Editor Portal | Edit My Paper</title>
          <meta name="viewport" content="width=1280, initial-scale=minimum-scale" />
        </Helmet>
        <TopNav />
        <br/><br/><br/><br/><br/>
        <div id="dashboard-student">
          <h1>Welcome</h1>
          <div className="editorbuttonwrapper">
            <div className={tab1} onClick={this.updateTab.bind(this, 1)}>
              Available Edits
            </div>
            <div className={tab2} onClick={this.updateTab.bind(this, 2)}>
              Edits in Progress
            </div>
            <div className={tab3} onClick={this.updateTab.bind(this, 3)}>
              Completed Edits
            </div>
            <div className={tab4} onClick={this.updateTab.bind(this, 4)}>
              Profile
            </div>
          </div>
          <br/>
          <div className={page1}>
            <table className="dashboard-paperlist">
              <tbody>
                <tr>
                  <th>Document Name</th>
                  <th>Word Count</th>
                  <th>Price</th>
                  <th>Time Limit</th>                
                  <th>Due Date</th>
                  <th>Accept</th>
                </tr>
                {newsubmissions}
              </tbody>
            </table>
            <Pager totalCount={this.props.EditorDashboard.availablePapersTotalCount} currentPage="1" clickHandler={this.getNextPageAvailable.bind(this)} pageSize="20"></Pager>
          </div>

          <div className={page2}>
            <table className="dashboard-paperlist">
              <tbody>
                <tr>
                  <th>Document Name</th>
                  <th>Word Count</th>
                  <th>Price</th>
                  <th>Time Limit</th>
                  <th>Submission Date</th>
                  <th>Due at:</th>
                  <th>Submit With Edits</th>
                  <th>Submit Clean Version</th>
                  {/*  ----- REMOVED FOR NOW - MISSING API -----
                  <th>Cancel This Edit</th>*/}
                  <th>Download</th>
                  <th>Complete Submission</th>
                </tr>
                {inedit_papers}
              </tbody>
            </table>
            <div className="verifyLoginMsg"><b>Before uploading either version, always refresh the page to ensure you have an active session.</b></div>
            <Pager totalCount={this.props.EditorDashboard.inProgressEditsTotalCount} currentPage="1" clickHandler={this.getNextPageInEdit.bind(this)} pageSize="20"></Pager>
            
          </div>

          <div className={page3}>
          {/*<button className='invoice-btn' onClick={this.generateInvoice.bind(this)}>Generate Invoice</button>*/}
          <br/>
          <br/><br/><br/>
            <table className="dashboard-paperlist">
              <tbody>
                <tr>
                  <th>Document Name</th>
                  <th>Price</th>
                  <th>Upload Date</th>
                  <th>Due Date</th>
                  <th>Rated</th>
                </tr>
                {complete_edits}
              </tbody>
            </table>
            <Pager totalCount={this.props.EditorDashboard.completedPapersTotalCount} currentPage="1" clickHandler={this.getNextPageCompleted.bind(this)} pageSize="20"></Pager>
          </div>

          <div className={page4}>
                <div>
                    <h2>My Profile</h2>
                    <ul>
                      <li>Email: {this.props.User.email}</li>
                      <li>Signup Date: {moment(this.props.User.signup_date).format("YYYY/MM/DD")}</li>
                    </ul>                    
                </div>
                <EditorProfileForm onSubmit={this.submitEditorUpdate} {...this.getEditorProfileProps()}></EditorProfileForm>
                <UpdatePassword></UpdatePassword>
          </div>

        </div>
      </div>
    )
  }
}

export default connect( ({Dashboard,EditorDashboard, User}) => ({Dashboard,EditorDashboard,User}) ) (EditorDashboard)

// <div className={page2}>
//   <table className="dashboard-paperlist">
//     <tr>
//       <th>Document Name</th>
//       <th>Word Count</th>
//       <th>Price</th>
//       <th>Time Limit</th>
//       <th>Submission Date</th>
//       <th>Due In:</th>
//       <th>Submit With Edits</th>
//       <th>Submit Finished</th>
//       <th>Download</th>
//       <th>Cancel This Edit</th>
//       <th>Complete Submission</th>
//     </tr>
//     <tbody>
//       {mySubmissions}
//     </tbody>
//   </table>
// </div>


// var duno_inedit_papers = this.props.EditorDashboard.editorSubmissionsinEdit.map((submission, i) => {
//   console.log('$$$$$$$$$$$$$$$$$$$$$$$$ how often are we in here $$$$$$$$$$$$$$$$$$$$$$$$');
//   var popup = classname({
//     'popup': true,
//     'easing': true,
//     'active': submission.active === true
//   })
//   return(
//     <tr className="paper-list" key={i}>
//       <td><Link to={`/editordashboard/view/${submission.doc_id}/`}>{submission.doc_name}</Link></td>
//       <td>{submission.word_count}</td>
//       <td>${submission.doc_cost}</td>
//       <td>{submission.time_limit}</td>
//       <td>{submission.upload_date}</td>
//       <td>{submission.due_date}</td>
//     </tr>
//   )
// })



// WEBPACK FOOTER //
// ./src/components/dashboards/EditorDashboard.js